import React from 'react';
import classNameBind from 'classnames/bind';
import Header from '../Header';
import Checkbox from '../Checkbox';
import { InnerList } from './components/InnerList';
import styles from './SearchableMultiselectListbox.module.css';
import ActionBar from './components/ActionBar';
import { SearchBar } from './components/SearchBar';
import { Pagination } from '../Pagination';

const bindClasses = classNameBind.bind(styles);

export default class SearchableMultiselectListbox extends React.Component {
  static defaultProps = {
    onReorder: null,
    isLoading: false,
    failedMessage: '',
    disabled: false,
    header: '',
    disabledTooltipText: null,
    search: null,
    dataId: 'SearchableMultiselectListbox',
    actionBarEnabled: true,
    adaptableHeight: false,
  };

  getLabelForSelectAll() {
    const { value, t, options, pagination } = this.props;
    const optionsIds = options.map(option => option.id);
    const filteredValue = value.filter(record => optionsIds.includes(record));
    const optionsNonDisabled = options.filter(option => !option.disabled);

    if (options.length < pagination.total) {
      return t('SearchableMultiselectListbox.selectAll.filtered', {
        filteredSelected: filteredValue.length,
        filtered: optionsNonDisabled.length,
        selected: value.length,
        total: pagination.total,
      });
    }

    if (options.length === 0) {
      return '';
    }

    return value.length > 0
      ? t('SearchableMultiselectListbox.selectAll.partiallySelected', {
        selected: value.length,
        total: optionsNonDisabled.length,
      })
      : t('SearchableMultiselectListbox.selectAll.noOptionSelected', { total: optionsNonDisabled.length });
  }

  handleSelectAll = () => {
    const { onChange, options, name, value } = this.props;
    const optionsIds = options.map(option => option.id);
    const filteredValue = value.filter(record => optionsIds.includes(record));
    const optionsNonDisabled = options.filter(option => !option.disabled);

    if (filteredValue.length === optionsNonDisabled.length) {
      onChange({
        target: {
          name,
          value: value
            .filter(option => !options.map(element => element.id)
              .includes(option)),
        },
      });
    } else {
      onChange({
        target: {
          name,
          value: [
            ...value,
            ...options
              .filter(option => !option.disabled)
              .map(option => option.id),
          ].filter((v, i, a) => a.indexOf(v) === i),
        },
      });
    }
  }

  handlePageChange = (event) => {
    const { pagination: { onChange, limit }, name } = this.props;

    onChange({
      target: {
        name,
        value: {
          offset: event,
          limit,
        },
      },
    });
  }

  handleLimitChange = (event) => {
    const { pagination: { onChange }, name } = this.props;

    onChange({
      target: {
        name,
        value: {
          offset: 0,
          limit: event,
        },
      },
    });
  }

  handleChange = (event) => {
    const { onChange, value } = this.props;
    const result = [...value];
    const index = value.indexOf(event.target.value);

    if (index >= 0) {
      result.splice(index, 1);
    } else {
      result.push(event.target.value);
    }

    onChange({
      target: {
        name: event.target.name,
        value: result,
      },
    });
  }

  render() {
    const {
      options, pagination, disabled, search, id, value, isLoading, header, failedMessage, onReorder,
      disabledTooltipText, name, dataId, actionBarEnabled, adaptableHeight, side, customListColumns, rightInfoChildren,
    } = this.props;
    const optionsIds = options.map(option => option.id);
    const filteredValue = value.filter(record => optionsIds.includes(record));
    const optionsNonDisabled = options.filter(option => !option.disabled);
    const selectAllDisabled = disabled || optionsNonDisabled.length === 0;

    return (
      <div
        id={id}
        className={bindClasses('SearchableMultiselectListbox')}
        data-ppuc-id={dataId}
      >
        {header && (
          <div className={bindClasses('header')}>
            <Header>
              {header}
            </Header>
          </div>
        )}
        {actionBarEnabled && (
          <ActionBar dataId={`${dataId}.ActionBar`}>
            <Checkbox
              id={`Transfer${id}`}
              name="selectAll"
              dataId={`${dataId}.selectAll`}
              label={this.getLabelForSelectAll()}
              value={options.length === filteredValue.length}
              checked={
                optionsNonDisabled.length > 0
                && optionsNonDisabled.length === filteredValue.length
              }
              onChange={this.handleSelectAll}
              disabled={selectAllDisabled}
            />
          </ActionBar>
        )}
        {search && (
          <SearchBar
            placeholder={search.placeholder}
            value={search.value}
            onChange={search.onChange}
            disabled={disabled}
            dataId={`${dataId}.SearchBar`}
          />
        )}
        {side === 'right' && rightInfoChildren && (
          <div className={bindClasses('right-info-children')}>
            {rightInfoChildren()}
          </div>
        )}
        <InnerList
          options={options}
          isLoading={isLoading}
          failedMessage={failedMessage}
          value={value}
          name={name}
          disabled={disabled}
          pagination={pagination}
          onReorder={onReorder}
          disabledTooltipText={disabledTooltipText}
          search={!!search}
          handleChange={this.handleChange}
          adaptableHeight={adaptableHeight}
          customListColumns={customListColumns}
        />
        {(pagination.total > 0 && !isLoading) && (
          <Pagination
            showTotal={false}
            onLimitChange={this.handleLimitChange}
            limitOptions={pagination.limitOptions}
            onPageChange={this.handlePageChange}
            limit={pagination.limit}
            total={pagination.total}
            startIndex={pagination.offset}
            endIndex={pagination.offset + pagination.limit}
            framed={false}
            dataId={`${dataId}.Pagination`}
          />
        )}
      </div>
    );
  }
}
